<div
  class="orgApp-lp-sidebar-overlay"
  [ngClass]="{ show: isSidebarVisible }"
  (keydown)="($event.key === 'Enter' || $event.key === ' ') && toggleSidebar()"
  (click)="toggleSidebar()"
></div>
<div class="orgApp-lp-sidebar" [ngClass]="{ show: isSidebarVisible }">
  <div class="orgApp-lp-sidebar-close">
    <svg width="24" height="24" class="orgApp-lp-sidebar-close-icon" (click)="toggleSidebar()" (keydown)="
            ($event.key === 'Enter' || $event.key === ' ') && toggleSidebar()
          " tabindex="0">
      <use xlink:href="#close-icon"></use>
    </svg>    
  </div>

  <mat-form-field class="orgApp-lp-sidebar-search-bar" appearance="outline">
    <svg width="20" class="orgApp-lp-sidebar-search-icon" height="20" viewBox="0 0 20 20" matPrefix>
      <use xlink:href="#search-icon"></use>
    </svg>
      
    <input matInput placeholder="Search" />
    <button mat-flat-button color="primary" type="submit" matSuffix>
      Search
    </button>
  </mat-form-field>

  <div
    class="orgApp-lp-popular-searches orgApp-flex-dir-col orgApp-d-flex orgApp-gap-20"
  >
    <h3 class="orgApp-lp-popular-searches-title">Popular Searches</h3>
    <div class="orgApp-gap-24 orgApp-flex-dir-row orgApp-d-flex">
      <button mat-stroked-button class="orgApp-custom-blue-border">
        Planning sheet
      </button>
      <button mat-stroked-button class="orgApp-custom-blue-border">
        Change password
      </button>
    </div>
  </div>
</div>
